/* eslint-disable import/no-anonymous-default-export */
import moment from "moment";

export default ({ steps = 60, start = "12:00am", end = "11:59pm" }) => {
  const timeRange = [];
  const time = moment(start, "hh:mma");

  while (time.valueOf() <= moment(end, "hh:mma").valueOf()) {
    timeRange.push({ time: time.format("hh:mma") });
    time.add(steps, "minutes");
  }

  return timeRange;
};
